import {JSONMapped, jsonProperty} from "json-mapper-reflect";

export class AvdbEventType extends JSONMapped() {

	@jsonProperty()
	uuid: string;

	@jsonProperty()
	name: string;

	constructor(data?: Partial<AvdbEventType>) {
		super();
		Object.assign(this, data);
	}
}

export enum AvdbEventTypes {
	INSTALLED 	= "Installed",
	DOWNLOADED 	= "Downloaded",
	ERROR 		= "Error",
}
